export function transformStatusCount(
  statusCount: Array<{ count: number; _id: string }>
): Array<{ name: string; count: number }> {
  // Initialize default statuses with a count of 0
  const defaultStatuses = {
    active: 0,
    inactive: 0,
  };

  // Populate counts from input, falling back to default values
  const statusMap = statusCount.reduce((acc, item) => {
    acc[item._id] = item.count;
    return acc;
  }, defaultStatuses);

  // Convert the status map back into an array with name and count
  return Object.entries(statusMap).map(([name, count]) => ({
    name,
    count,
  }));
}
export function addSpaceAfterComma(input: string): string {
  return input.replace(/,/g, ", ");
}
export function cleanCommas(input: string) {
  if (!input) {
    return "-";
  }
  return input
    .split(",")
    .map((item) => item.trim()) // remove surrounding spaces
    .filter((item) => item) // remove empty items
    .join(", "); // join with single comma and space
}
